









































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import { NoteModel, NotesClient } from "@/diamond-support-api";
import { ErrorMessage, SuccessMessage, SystemMessage } from "@/shared";

@Component
export default class NoteAdd extends Vue {
  @Action("showMessage", { namespace: "notification" }) showMessage: any;

  shown = true;
  loading = false;

  notes: NoteModel = new NoteModel();
  notesApi = new NotesClient();

  mounted() {}

  async save() {
    if (this.$route.params.id) {
      this.notes.distributorId = this.$route.params.id;
      this.loading = true;
      await this.notesApi
        .post(this.notes)
        .then((response) => {
          if (response !== null) 
          this.showMessage(new SuccessMessage(`New note has been saved.`));
        })
        .catch((error) => {
          console.log(error);
          this.showMessage(new ErrorMessage(`An error occured: \r\n${error}`));
        });
    }
    this.shown = false;
  }


  @Watch("shown")
  onShownChanged() {
    if (!this.shown)
      this.$router.push(`/associates/${this.$route.params.id}/detail`);
  }
}
